export default {"src":"/_next/static/media/battery-full.38cb58d3.svg","height":800,"width":800};